import { useContext } from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { ToolContext } from '../../../../core/context/ToolContext';
import { Form } from './form/Index';

export const Product = () => {
    const { setup_state } = useContext(ToolContext);
    const { prdctModalForm } = setup_state;

    const showModal = (isOpen) => {
        prdctModalForm.set({ ...prdctModalForm.data, toggled: isOpen, id: "" })
    }

    return (
        <Box>
            <Stack flexDirection="row" py="1rem" alignItems="center" justifyContent="space-between">
                <Typography fontSize="1.25rem" fontWeight="700">Product List</Typography>
                <Box component={Button} variant="contained" fontSize={14} color="#fff" borderRadius={2} px={4} py={1} sx={{ ':hover': { bgcolor: '#009F4D', color: '#fff' } }} onClick={() => showModal(true)} >Add Product</Box>
            </Stack>
            { prdctModalForm.data.toggled && <Form showModal={showModal}/>}
        </Box>
    )
}
